(function(){
  'use strict';

  angular
    .module('app')
  	.constant('apiConfig', {
      url: 'https://brastelha.ind.br/api',
      hashUpload: '07c779ffd2a01829b343b763bc399ec346',
  	  urlImages: 'https://api.o2.ag/api_cms/uploads'
    });

})();
